import React from 'react';
import useClock from '../../../Utils/Hooks/useClock';
import { IoMdAlarm } from 'react-icons/io';

const RealTime = () => {
  const { day, month, year, time } = useClock();
  return (
    <div className='real-date-time'>
      <div className='real-date'>
        {day}, {month}, {year}
      </div>
      <div className='real-time d-flex align-items-center'>
        <IoMdAlarm className='iocn-bell me-2' />
        {time}
      </div>
    </div>
  );
};

export default RealTime;
